import React, { createContext, useState } from 'react';


export const BillingSummaryContext = createContext();


export const BillingSummaryProvider = ({ children }) => {

  const [billSummaryKeyValue, setBillSummaryKeyValue] = useState("");
  
  return (
    <BillingSummaryContext.Provider value={{billSummaryKeyValue, setBillSummaryKeyValue }}>
      {children}
    </BillingSummaryContext.Provider>
  );
};